import { API_NAMES, initApi } from "../../../utils/HttpApiHelper";

const getFacilityAffiliationTypeData = (state, setState) => {
    const api = initApi(API_NAMES.CLUB, state, setState);
    const url = `/Facility/FacilityAffiliationType`;

    return api?.executeArray ? api.executeArray(url, 'GET') : null;
};

const FacilityAffiliationTypeData = {
    getFacilityAffiliationTypeData
};

export default FacilityAffiliationTypeData;